import { createContext, useContext, useState, useEffect } from "react";

// ── PRESETS DE TEMA ──────────────────────────────────────────────
const PRESETS = {
  noite: {
    bg: "#0B0B12", sidebar: "#0F0F18", card: "#14141F", cardHover: "#1A1A28",
    border: "#1E1E2E", text: "#FFFFFF", textMuted: "#6B7280", textSoft: "#9CA3AF",
    red: "#E8201A", green: "#1B8C2D", greenLight: "#22C55E",
    yellow: "#FACC15", blue: "#3B82F6", purple: "#8B5CF6", orange: "#F97316",
  },
  dia: {
    bg: "#F4F4F8", sidebar: "#FFFFFF", card: "#FFFFFF", cardHover: "#F0F0F5",
    border: "#E2E2EC", text: "#111118", textMuted: "#6B7280", textSoft: "#4B5563",
    red: "#D41810", green: "#166524", greenLight: "#16A34A",
    yellow: "#CA8A04", blue: "#2563EB", purple: "#7C3AED", orange: "#EA580C",
  },
  escuro: {
    bg: "#000000", sidebar: "#0A0A0A", card: "#111111", cardHover: "#1A1A1A",
    border: "#222222", text: "#FFFFFF", textMuted: "#555555", textSoft: "#888888",
    red: "#FF2D20", green: "#22C55E", greenLight: "#4ADE80",
    yellow: "#FBBF24", blue: "#60A5FA", purple: "#A78BFA", orange: "#FB923C",
  },
  grafite: {
    bg: "#1A1A2E", sidebar: "#16213E", card: "#0F3460", cardHover: "#1A3A6E",
    border: "#0F3460", text: "#E0E0FF", textMuted: "#7C7CAA", textSoft: "#A0A0CC",
    red: "#E94560", green: "#00B74A", greenLight: "#39D98A",
    yellow: "#FFD700", blue: "#4CC9F0", purple: "#9B5DE5", orange: "#F77F00",
  },
};

const FONT_SIZES = { pequeno: 12, normal: 14, grande: 16, extragrande: 18 };

const DEFAULT_STATE = {
  preset: "noite",
  accentColor: "#E8201A",
  fontSize: "normal",
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [config, setConfig] = useState(() => {
    try {
      const saved = localStorage.getItem("mixup_theme_config");
      return saved ? { ...DEFAULT_STATE, ...JSON.parse(saved) } : DEFAULT_STATE;
    } catch { return DEFAULT_STATE; }
  });

  useEffect(() => {
    localStorage.setItem("mixup_theme_config", JSON.stringify(config));
    const fs = FONT_SIZES[config.fontSize] || 14;
    document.documentElement.style.setProperty("--mixup-font-size", `${fs}px`);
  }, [config]);

  const theme = {
    ...PRESETS[config.preset] || PRESETS.noite,
    red: config.accentColor,
  };

  const updateConfig = (patch) => setConfig(prev => ({ ...prev, ...patch }));

  return (
    <ThemeContext.Provider value={{ theme, config, updateConfig, PRESETS, FONT_SIZES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be inside ThemeProvider");
  return ctx;
}

// Compatibilidade: exporta tema estático padrão para arquivos que importam direto
export default PRESETS.noite;
